import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private authSvc: AuthService,
    private router: Router,
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next
      .handle(req)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler(error)));
  }

  errorHandler(error: HttpErrorResponse) {
    console.log('🔴 ERROR INTERCEPTOR - HttpErrorResponse completo:', error);
    console.log('🔴 ERROR INTERCEPTOR - error.error:', error.error);
    console.log(
      '🔴 ERROR INTERCEPTOR - error.error?.message:',
      error.error?.message,
    );
    console.log(
      '🔴 ERROR INTERCEPTOR - error.error?.error:',
      error.error?.error,
    );
    console.log(
      '🔴 ERROR INTERCEPTOR - error.error?.error?.message:',
      error.error?.error?.message,
    );

    // Handle auth errors (401/403) - logout and redirect
    if (
      (error.status === 401 || error.status === 403) &&
      !this.router.url.includes('/auth')
    ) {
      this.logOut();
      return throwError({
        status: error.status,
        message: 'Sesión expirada o no autorizado',
        rawError: error,
        isAuthError: true,
      });
    }

    // Handle special 404 companyYield case
    if (error.status === 404 && error.error?.path?.includes('companyYield')) {
      return throwError({
        status: 404,
        message: 'Company yield not found',
        rawError: error,
        isSilentError: true,
      });
    }

    // Extract and structure error message for all other cases
    let message = 'Algo pasó, vuelve a intentarlo';

    // Try multiple extraction paths in priority order
    try {
      // Path 1: Direct message in error body (most common)
      if (error.error?.message) {
        console.log(
          '✅ Mensaje extraído de error.error.message:',
          error.error.message,
        );
        message = error.error.message;
      }
      // Path 2: Nested error message (legacy structure)
      else if (error.error?.error?.message) {
        console.log(
          '✅ Mensaje extraído de error.error.error.message:',
          error.error.error.message,
        );
        message = error.error.error.message;
      }
      // Path 3: Message in response object (for internal codes)
      else if (error.error?.response?.message) {
        console.log(
          '✅ Mensaje extraído de error.error.response.message:',
          error.error.response.message,
        );
        message = error.error.response.message;
      }
      // Path 4: Direct HttpErrorResponse message
      else if (error.message && error.message !== 'Http failure response') {
        console.log('✅ Mensaje extraído de error.message:', error.message);
        message = error.message;
      }
      // Path 5: HTTP status text as fallback
      else if (error.statusText && error.statusText !== 'Unknown Error') {
        console.log(
          '✅ Mensaje extraído de error.statusText:',
          error.statusText,
        );
        message = `Error: ${error.statusText}`;
      }

      // Development logging to help identify error structure
      if (
        !environment.production &&
        message === 'Algo pasó, vuelve a intentarlo'
      ) {
        console.warn('⚠️ Could not extract error message. Error structure:', {
          status: error.status,
          errorBody: error.error,
          message: error.message,
          statusText: error.statusText,
        });
      }
    } catch (e) {
      console.error('Error extracting message from backend error:', e);
    }

    // Server errors get a more specific message if extraction failed
    if (error.status >= 500 && message === 'Algo pasó, vuelve a intentarlo') {
      message = 'Error del servidor. Por favor, intente nuevamente más tarde.';
    }

    console.log('🔴 ERROR INTERCEPTOR - Mensaje final extraído:', message);

    // Return standardized error structure
    const errorObject = {
      status: error.status,
      message: message,
      rawError: error,
      timestamp: error.error?.timestamp,
      path: error.error?.path,
    };

    console.log(
      '🔴 ERROR INTERCEPTOR - Objeto de error retornado:',
      errorObject,
    );

    return throwError(errorObject);
  }

  logOut() {
    this.authSvc.logout();
    this.router.navigate(['/auth']);
  }
}
